import { type FC } from 'react'
import { CurrencyDollarIcon, KeyIcon, ChartPieIcon } from '@heroicons/react/24/outline'
import { useTranslation } from '@egw/i18n'
import { WelcomeStepV2 } from '../welcome-step-v2/welcome-step-v2'

// When other Person has not accepted disclosures
export const WelcomeStepsJointV1: FC<{ jointPersonFirstName: string }> = ({ jointPersonFirstName = '' }) => {
  const { t } = useTranslation('features-enrollment')

  return (
    <>
      <WelcomeStepV2
        icon={<KeyIcon className="size-6" />}
        testId="fund-checking"
        title={t('joint.welcome.steps.step_1.title')}
        description={`${t('joint.welcome.steps.step_1.description_1')} ${jointPersonFirstName} ${t('joint.welcome.steps.step_1.description_2')}`}
      />
      <WelcomeStepV2
        icon={<CurrencyDollarIcon className="size-6" />}
        testId="earn-with-savings"
        title={t('joint.welcome.steps.step_2.title_yeet_coastal')}
        description={t('joint.welcome.steps.step_2.description')}
      />
      <WelcomeStepV2
        icon={<ChartPieIcon className="size-6" />}
        testId="optimize-investments"
        title={t('joint.welcome.steps.step_3.title')}
        description={t('joint.welcome.steps.step_3.description')}
      />
    </>
  )
}
